import api from '@/services/api';
import SearchQuery from '@/utils/SearchQuery';
import { PageDTO } from '@/dtos/generics';
import BindingsDTO from '@/dtos/bindings/BindingsDTO';
import CreateBindingsDTO from '@/dtos/bindings/CreateBindingsDTO';
import BindingGenealogyDTO from '@/dtos/bindings/BindingGenealogyDTO';

const bindingsProvider = {
  async list(
    filters: SearchQuery,
    page?: number
  ): Promise<PageDTO<BindingsDTO>> {
    try {
      const { data } = await api.get<PageDTO<BindingsDTO>>(`/bindings`, {
        params: { ...filters.query, page },
      });
      return data;
    } catch (error) {
      console.error('Erro ao buscar bindings:', error);
      throw error;
    }
  },

  async listFiltered(filters: SearchQuery): Promise<PageDTO<BindingsDTO>> {
    try {
      const { data } = await api.get<PageDTO<BindingsDTO>>(
        `/bindings/filtered`,
        {
          params: {
            search: filters.search,
            page: filters.page,
            perPage: filters.size,
          },
        }
      );
      return data;
    } catch (error) {
      console.error('Erro ao buscar bindings filtrados:', error);
      throw error;
    }
  },

  async create(bindings: CreateBindingsDTO): Promise<BindingsDTO> {
    try {
      const { data } = await api.post<BindingsDTO>('/bindings', bindings);
      return data;
    } catch (error) {
      console.error('Erro ao criar bindings:', error);
      throw error;
    }
  },

  async findByBindCode(bindCode: string): Promise<BindingsDTO> {
    try {
      const { data } = await api.get<BindingsDTO>(`/bindings/${bindCode}`);
      return data;
    } catch (error) {
      console.error('Erro ao procurar bindings:', error);
      throw error;
    }
  },

  async findByChildCode(childCode: string): Promise<BindingsDTO> {
    try {
      const { data } = await api.get<BindingsDTO>(`/bindings/child/${childCode}`);
      return data;
    } catch (error) {
      console.error('Erro ao procurar bindings:', error);
      throw error;
    }
  },

  async trace(code: string): Promise<BindingGenealogyDTO[]> {
    const { data } = await api.get(`/bindings/trace/${code}`);
    return data;
  },
};

export default bindingsProvider;
